/* unplugin-vue-components disabled */import script from "./TravelAreaManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelAreaManager.vue?vue&type=script&setup=true&lang=js"

import "./TravelAreaManager.vue?vue&type=style&index=0&id=12f10b79&lang=css"

const __exports__ = script;

export default __exports__